<template>
    <v-card width="auto" tile>
        <v-form ref="form">
            <v-card-text>
                <v-row dense>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="model.slug"
                      label="Clave Role"
                      :rules="fieldRequired"
                      outlined
                      dense>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="model.nombre"
                      label="Nombre Role"
                      :rules="fieldRequired"
                      outlined
                      dense>
                    </v-text-field>
                  </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cancelar</v-btn>
                <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  name: 'RoleFormCreate',
  mixins: [Validate],
  props: ['model', 'onSuccess', 'onCancel'],
  data: () => ({}),
  methods: {
    save () {
      if (this.$refs.form.validate()) {
        this.onSuccess(this.model)
      }
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  }

}
</script>

<style>

</style>
